import styled, { css } from 'styled-components';

export const ReportDataProfileContainer = styled.div`
  ${() => css`
    padding: 20px 0;
  `}
`;

export const BoxReportItens = styled.div``;

export const ReportItem = styled.div`
  ${() => css`
    border: 1px solid #eee;
    border-radius: 3px;
    margin-bottom: 20px;
    padding: 20px;
    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;

      color: #235f6e;
      margin-bottom: 10px;
      display: block;
    }

    div.subItens {
      margin-top: 15px;
      margin-left: 10px;

      h3 {
        color: #444;
      }
      p {
        margin-left: 10px;
      }
    }
  `}
`;

export const BoxButton = styled.div`
  ${() => css`
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;
